import {createContext, useContext, useLayoutEffect, useRef, useState} from "react";
import {getLiveBackground} from "./backgrounds";
import "./liveBackground.css";
import LiveOverlay from "./LiveOverlay";
import {LiveAudioAutostart} from "../liveAudio/LiveAudio";
import {getLiveTextStyle} from "../../constant/liveOutlineColors";

export const LiveBackgroundContext = createContext(null);
export const useLiveBackground = () => useContext(LiveBackgroundContext);

// Scale the complete broadcast frame, including its header and footer, together.
function FittedBackground({
                              background,
                              children,
                              className,
                              marqueeText,
                              preserveInnerBackgrounds,
                              variant,
                              id,
                              textStyle
                          }) {
    const viewportRef = useRef(null);
    const [scale, setScale] = useState(0);

    useLayoutEffect(() => {
        const viewport = viewportRef.current;
        const fit = () => {
            setScale(Math.min(viewport.clientWidth / 1920, viewport.clientHeight / 1080));
        };
        fit();
        const observer = new ResizeObserver(fit);
        observer.observe(viewport);
        return () => observer.disconnect();
    }, []);

    return <div ref={viewportRef} className="live-background" style={{
        backgroundImage: background ? `url(${background})` : undefined,
    }}>
        <LiveAudioAutostart/>
        <div id={id}
             className={`live-background__stage ${variant ? `live-background__stage--${variant}` : ""} ${preserveInnerBackgrounds ? "" : "live-background__stage--plain"} ${className}`}
             style={{
                 transform: `translate(-50%, -50%) scale(${scale})`,
                 visibility: scale > 0 ? "visible" : "hidden",
             }}>
            {children}
            <LiveOverlay
                marqueeText={marqueeText}
                textStyle={textStyle}
            />
        </div>
    </div>;
}

// Existing pages keep their original root element unless a new route opts in.
export default function LiveBackground({
                                           result,
                                           children,
                                           className = "",
                                           marqueeText,
                                           preserveInnerBackgrounds,
                                           variant,
                                           id
                                       }) {

    const rawRouteType = useLiveBackground();
    const routeType =
        typeof rawRouteType === "string"
            ? rawRouteType.trim().toLowerCase()
            : "";
    const textStyle = getLiveTextStyle(routeType);
    if (!routeType) return <div id={id} className={className}>{children}</div>;
    return <FittedBackground
        background={getLiveBackground(routeType, result)}
        className={className}
        marqueeText={marqueeText}
        variant={variant}
        id={id}
        textStyle={textStyle}
        preserveInnerBackgrounds={
            preserveInnerBackgrounds ?? ["sc", "kh", "leap"].includes(routeType.toLowerCase())
        }
    >
        {children}
    </FittedBackground>;
}
